import request from './request';

export async function list(
  sortBy: string,
  sortOrder: string
): Promise<{ courses: any[] }> {
  return request('GET', '/api/courses', { sortBy, sortOrder });
}

export async function create(
  cipher: string,
  name: string,
  nameEn: string,
  nameDe: string,
  description: string,
  descriptionEn: string,
  descriptionDe: string,
  active?: boolean,
  acceptsRequests?: boolean,
  shortDescription?: string,
  shortDescriptionEn?: string,
  shortDescriptionDe?: string,
  priority?: number
) {
  return request('POST', '/api/courses', {
    active,
    acceptsRequests,
    cipher,
    name,
    nameEn,
    nameDe,
    description,
    descriptionEn,
    descriptionDe,
    shortDescription,
    shortDescriptionEn,
    shortDescriptionDe,
    priority,
  });
}

export async function update(
  id: string,
  cipher: string,
  name: string,
  nameEn: string,
  nameDe: string,
  description: string,
  descriptionEn: string,
  descriptionDe: string,
  active?: boolean,
  acceptsRequests?: boolean,
  shortDescription?: string,
  shortDescriptionEn?: string,
  shortDescriptionDe?: string,
  priority?: number
) {
  return request('POST', `/api/courses/${id}`, {
    active,
    acceptsRequests,
    cipher,
    name,
    nameEn,
    nameDe,
    description,
    descriptionEn,
    descriptionDe,
    shortDescription,
    shortDescriptionEn,
    shortDescriptionDe,
    priority,
  });
}

export async function setActive(id: string, active: boolean) {
  return request('POST', `/api/courses/${id}`, { active });
}

export async function setAcceptsRequests(id: string, acceptsRequests: boolean) {
  return request('POST', `/api/courses/${id}`, { acceptsRequests });
}

export async function getQueue(
  id: string,
  sortColumn?: string,
  sortOrder?: string
): Promise<{ queue: any[] }> {
  return request(
    'GET',
    `/api/courses/${id}/queue?sortColumn=${sortColumn}&sortOrder=${sortOrder}`
  );
}

export async function addToQueue(
  id: string,
  requestIds?: string[],
  studentIds?: string[]
) {
  return request('POST', `/api/courses/${id}/queue`, {
    requestIds,
    studentIds,
  });
}

export async function removeFromQueue(id: string, studentIds: string[]) {
  return request('DELETE', `/api/courses/${id}/queue`, { studentIds });
}

export async function remove(id: string) {
  return request('DELETE', `/api/courses/${id}`);
}
